import { CJA_EVENTS } from './constants.js';
import { setUserInfoObj, getSdkBasedOnEnvironment } from './utils.js';

/* This code snippet is exporting a default object with an `install` method. The `install` method is
intended to be used as a plugin installation function in a Vue.js application. */
export default {
  install(app, options = {}) {
    const setupPageInfoGlobal = async () => {
      const pageInfoGlobal = {
        event: CJA_EVENTS.PAGE_LOAD,
        eventInfo: CJA_EVENTS.REGULAR_PAGE_LOAD,
        hasCustomPageLoad: true,
        pageInfo: {
          pageName: '',
          pageSection: '',
          pageUrl: ''
        },
        userInfo: {
          userRole: '',
          foundryName: '',
          userStatus: '',
          oAuthId: '',
          userConsent: '',
          consentGroup: '',
          encryptedUserEmail: '',
        },
        pageError: {
          errorCode: '',
          errorMessage: '',
          errorType: ''
        }
      };
      window.pageInfoGlobal = JSON.parse(JSON.stringify(pageInfoGlobal));
      await setUserInfoObj();
    };

    const loadAnalyticsScripts = adobe => {
      const existingScript = document.querySelector('script[nonce]');
      const nonce = existingScript ? existingScript['nonce'] : '';

      // Load the Adobe scripts
      const adobeScript = document.createElement('script');
      if (nonce) {
        adobeScript.nonce = nonce;
      }
      adobeScript.src = adobe;
      if (options.async) adobeScript.async = true;
      adobeScript.onload = () => {
        console.debug('[CJA Logs]: Adobe Launch script loaded');
      };
      adobeScript.onerror = () => {
        console.error('[CJA Logs]: Failed to load Adobe Launch script');
      };

      // Append script to the document head
      document.head.appendChild(adobeScript);
    };

    const adobeSDK = getSdkBasedOnEnvironment();

    if (adobeSDK) {
      setupPageInfoGlobal();
      loadAnalyticsScripts(adobeSDK);
    } else {
      console.error(
        '[CJA Logs]: Analytics scripts not loaded: Check environment configuration, ensure enabled in .env file'
      );
    }
  }
};
